import uniqid from "uniqid";

import { useState } from "react";

import { ArtifactFile } from "astrid-firestore/src/api/artifacts/types/ArtifactFile";
import useBucket from "astrid-hooks/src/useBucket";

export default function useArtifactFilesUpload() {
	const [progress, setProgress] = useState({});

	const { putFiles, unzipAndPutFiles } = useBucket("earselect-artifacts");

	const uploadArtifactFiles = async (folder, files) => {
		const zips = files.filter((file) => file.name.endsWith(".zip"));
		const nonZips = files.filter((file) => !file.name.endsWith(".zip"));

		const uploadedNonZips = await putFiles(nonZips, {
			getPath: (file) => {
				const id = uniqid();
				const ext = file.name.split(".").pop();

				return `${folder}/${id}.${ext}`;
			},
			onProgress: (progress) => {
				setProgress(progress);
			},
		});

		const parsedUploadedNonZips = uploadedNonZips.map((metadata, index) => {
			const file = files[index];
			const id = metadata.name.split(".")[0];

			return ArtifactFile.parse({
				...metadata,
				id,
				name: file.name,
			});
		});

		const parsedUploadedZips = [];

		if (zips.length > 0) {
			for (const zip of zips) {
				const files = await unzipAndPutFiles(zip, {
					folder,
					onProgress: (zipProgress) => {
						setProgress((progress) => ({ ...progress, ...zipProgress }));
					},
				});

				parsedUploadedZips.push(...files.map((file) => ArtifactFile.parse(file)));
			}
		}

		return [...parsedUploadedNonZips, ...parsedUploadedZips];
	};

	return {
		uploadArtifactFiles,
		progress,
	};
}
